//==============================
// Themes
//==============================

const getTheme = new URLSearchParams(window.location.search);
const theme = getTheme.get('theme');
// console.log(theme);

if (getTheme !='') {

  setTimeout(function() {
    $('a').each(function() {
      var thisItem = $(this);
      thisItem.attr('href');
      var thisHref = thisItem.attr('href');
      thisItem.attr('href', thisHref + '?theme=' + theme + '');
    });
  }, 1500);

  $('link[rel="stylesheet"]').each(function () {
      var href = $(this).attr('href');

      if (href && href.indexOf('onyx.css') !== -1) {
          var newHref = href.replace('onyx.css', theme + '.css');
          $(this).attr('href', newHref);
      }
  });
}